// Main cart Page
$(document).on("click", ".line-item__quantity-remove", function (e) {
  e.preventDefault();
  var $link = $(this);
  var var_id = parseInt($link.closest(".line-item-cus").attr("variant-id"), 10);
  console.log("Clicked Variant ID:", var_id);

  var line = $link.data("line");
  var mainProductId = parseInt(
    $(".line-item__property-2").attr("varient_property"),
    10
  );

  console.log("Removing line:", line, "Main Product ID:", mainProductId);
  var selected_var = $(".hidden_mini_cart").attr("variant-id");
  console.log("Hidden mini cart variant ID:", selected_var);
  if (selected_var) {
    removeProductFromCart(selected_var);
  }
  removeItemsFromCart(mainProductId);
});

function removeProductFromCart(variant_id) {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var updates = {};

      console.log("Cart Items:", cart.items);
      cart.items.forEach((item) => {
        console.log(
          "Checking cart item:",
          item.variant_id,
          "Selected Variant ID:",
          variant_id
        );
        if (item.variant_id === parseInt(variant_id, 10)) {
          updates[item.id] = 0;
        }
      });

      console.log("Updates Object:", updates);

      if (Object.keys(updates).length > 0) {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: { updates: updates },
          dataType: "json",
          beforeSend: function () {
            document.dispatchEvent(new CustomEvent("theme:loading:start"));
          },
          success: function (updatedCart) {
            console.log("Product removed successfully:", updatedCart);
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:loading:end", { bubbles: true })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: true })
            );
            openCartDrawer();
          },
          error: function (xhr, status, error) {
            console.log("Error updating cart:", xhr.responseText);
          },
        });
      } else {
        console.log("No matching product found for removal.");
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
        openCartDrawer();
      }
    },
    error: function (error) {
      console.log("Error fetching cart:", error);
    },
  });
}

function removeItemsFromCart(mainProductId) {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var updates = {};

      console.log("Cart Items:", cart.items);

      cart.items.forEach((item) => {
        console.log(
          "Checking cart item:",
          item.variant_id,
          "Main Product ID:",
          mainProductId
        );
        if (item.variant_id === mainProductId) {
          updates[item.id] = 0;
        }
      });
      console.log("Updates Object:", updates);

      if (Object.keys(updates).length > 0) {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: { updates: updates },
          dataType: "json",
          success: function (updatedCart) {
            console.log(
              "Main product & related variants removed successfully:",
              updatedCart
            );
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:loading:end", { bubbles: true })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", { bubbles: true })
            );
            openCartDrawer();
          },
          error: function (xhr, status, error) {
            console.log("Error updating cart:", xhr.responseText);
          },
        });
      } else {
        console.log("No matching products found for removal.");
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:end", { bubbles: true })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
        openCartDrawer();
      }
    },
    error: function (error) {
      console.log("Error fetching cart:", error);
    },
  });
}

// cart Drawer

$(document).ready(function () {
  var minQuantity = 2;
  var $quantityInput = $(".custom-quantity-input");

  // Initialize quantity to 2 if empty
  if (!$quantityInput.val()) {
    $quantityInput.val(minQuantity);
  }

  // Decrease button functionality
  $(".custom-decrease-btn").on("click", function () {
    var currentValue = parseInt($quantityInput.val());
    if (currentValue > minQuantity) {
      $quantityInput.val(currentValue - 1);
    }
    toggleDecreaseButton();
  });

  // Increase button functionality
  $(".custom-increase-btn").on("click", function () {
    var currentValue = parseInt($quantityInput.val());
    $quantityInput.val(currentValue + 1);
    toggleDecreaseButton();
  });

  // Ensure minimum value on input change
  $quantityInput.on("input", function () {
    var currentValue = parseInt($(this).val());
    if (isNaN(currentValue) || currentValue < minQuantity) {
      $(this).val(minQuantity);
    }
    toggleDecreaseButton();
  });

  function toggleDecreaseButton() {
    var currentValue = parseInt($quantityInput.val());
    $(".custom-decrease-btn").prop("disabled", currentValue <= minQuantity);
  }

  // Initialize button state
  toggleDecreaseButton();
});

// End product page
$(document).on("click", ".ctm-ATC-button", function () {
 var $button = $(this);
  var originalText = $button.text();
   $button.prop("disabled", true).text("Adding...");
  var selectedQuantity = $(".custom-quantity-input").val();
  console.log("Selected Quantity:", selectedQuantity);

  var selectedVariantId = $(".select-wrapper select").val();
  console.log("Selected Variant ID:", selectedVariantId);

  var selectedVariantTitle = $(".select-wrapper select option:selected").attr(
    "varient_title"
  );
  console.log("Selected Variant Title:", selectedVariantTitle);


    var dataVarId = $('.addon_pro_sim[variant-title="'+selectedVariantTitle+'"]').attr('data-main-product');

  var selling_plan_id = $(".addon_pro_sim").attr("selling_plan_id");
  console.log("Selected Addon Product:", selling_plan_id);

  var addon_ids = [];
  addon_ids.push({
    id: selectedVariantId,
    quantity: selectedQuantity,
  });
  addon_ids.push({
    id: dataVarId,
    quantity: selectedQuantity,
    selling_plan: selling_plan_id,
    properties: {
      Sim: selectedVariantTitle,
      Product: selectedVariantId,
    },
  });
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify({ items: addon_ids }),
    success: function (data) {
      document.dispatchEvent(new CustomEvent("theme:loading:start"));
      // alert("Working");

      $.ajax({
        type: "GET",
        url: "/cart",
        success: function (cart) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
          );
             $button.text("Added!");

          setTimeout(function () {
          
            $button.text(originalText).prop("disabled", false);
          }, 2000);
          setTimeout(openCartDrawer, 800);
          // openCartDrawer();
        },
        error: function (xhr, status, error) {
          alert("Error refreshing cart: " + xhr.responseText);
        },
      });
    },
    error: function (error) {
      console.log(error);
    },
  });

});


function openCartDrawer() {
  const miniCart = document.querySelector(".mini-cart");
  if (miniCart) {
    miniCart.setAttribute("aria-hidden", "false");
  }
}


// document.addEventListener('DOMContentLoaded', () => {
// const checkbox = document.getElementById('myCheckboxEvent');
// const button_ = document.getElementById('checkout_cus_btn');

// checkbox.addEventListener('change', () => {
//   alert('ok');
//   if (checkbox.checked) {
//     button_.removeAttribute('disabled');
//   } else {
//     button_.setAttribute('disabled', 'disabled');
//   }
// });
// });


document.addEventListener('change', (e) => {
  // alert('ok');
  
  if (e.target.id === 'myCheckboxEvent') {
    const button_ = document.getElementById('checkout_cus_btn');
    if (e.target.checked) {
      button_.removeAttribute('disabled');
    } else {
      button_.setAttribute('disabled', 'disabled');
    }
  }
});
